/**
 * Derive the persisted subtype for a post without attached media.
 *
 * Keep this shared by authoring preview and persistence so a draft cannot
 * preview as Text Story and then publish as Article (or the reverse).
 */
export function deriveTextualMediaType(titleText = "", captionText = "") {
  const title = String(titleText || "").trim();
  const caption = String(captionText || "").trim();

  if (title && !caption) return "poster";
  if (!title && caption) return caption.length <= 140 ? "tweet" : "post";
  if (title && caption) {
    return `${title} ${caption}`.length <= 140 ? "tweet" : "post";
  }
  return "poster";
}
